import { useState, useEffect } from "react";
import { authService } from "../services/authService";

export const useAuth = () => {
    // Read localStorage on the first render so logged-in UI (e.g. Edit on
    // BlogCard) is not gated behind a post-mount effect that starts as false.
    const [isAuthenticated, setIsAuthenticated] = useState<boolean>(() =>
        authService.isLoggedIn()
    );

    useEffect(() => {
        setIsAuthenticated(authService.isLoggedIn());
        const unsubscribe = authService.subscribe((isAuth) => {
            setIsAuthenticated(isAuth);
        });
        return () => {
            unsubscribe();
        };
    }, []);

    const login = async (username: string, password: string) => {
        try {
            const response = await authService.login(username, password);
            if (response.accessToken) {
                setIsAuthenticated(true);
                return true;
            }
        } catch (error) {
            console.error("Login failed:", error);
        }
        return false;
    };

    const logout = () => {
        authService.logout();
        setIsAuthenticated(false);
    };

    return {
        isAuthenticated,
        login,
        logout,
    };
};
